module.exports = __webpack_public_path__ + "static/media/magento.09c7aa05.png";